export default __webpack_public_path__ + "static/media/multitool.4f1edd35.glb";